import State from '../core/State';
import { VisitorData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingVisitorsBySalesRate = () =>
  produce((draft: Draft<State>) => {
    draft.purchaseRates.fetching = draft.purchaseRates.fetching + 1;
  });

export const setVisitorsBySalesRate = (visitorData: VisitorData) =>
  produce((draft: Draft<State>) => {
    draft.purchaseRates.data = visitorData;
  });

export const finishFetchingVisitorsBySalesRate = () =>
  produce((draft: Draft<State>) => {
    draft.purchaseRates.fetching = draft.purchaseRates.fetching - 1;
  });

export const disposeVisitorsBySalesRate = () =>
  produce((draft: Draft<State>) => {
    draft.purchaseRates.data = initialState.purchaseRates.data;
    draft.purchaseRates.fetching = initialState.purchaseRates.fetching;
  });
